import { Loader } from "../../../../../../UI/Loaders/Loaders";
import useGetUserLockHistory from "../../../../hooks/useGetUserLockHistory";

export default function LockHistoryTab({ ssoUserId }) {
  const { data: lockHistoryData, isLoading } = useGetUserLockHistory({
    ssoUserId,
  });

  if (isLoading) {
    return <Loader centered text="Loading lock history..." />;
  }

  if (!lockHistoryData?.data?.length) {
    return (
      <p className="text-center text-muted p-y-3">
        No lock history found for this user.
      </p>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead className="bg-lighter-grey">
          <tr>
            <th>S/N</th>
            <th>Lock Type</th>
            <th>Reason</th>
            <th>Additional Info</th>
            <th>Performed By</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {lockHistoryData.data.map((entry, index) => (
            <tr key={entry.id}>
              <td>{index + 1}</td>
              <td>
                <span
                  className={`badge ${
                    entry.lockType?.toLowerCase() === "lock"
                      ? "badge-danger"
                      : "badge-success"
                  }`}
                >
                  {entry.lockType}
                </span>
              </td>
              <td>{entry.reason}</td>
              <td>{entry.additionalInfo || "—"}</td>
              <td>{entry.operatorName}</td>
              <td>
                {entry.createdAt ? entry.createdAt.substring(0, 10) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
